import { render, staticRenderFns } from "./Mensagens.vue?vue&type=template&id=75174be2&scoped=true"
import script from "./Mensagens.vue?vue&type=script&lang=js"
export * from "./Mensagens.vue?vue&type=script&lang=js"
import style0 from "./Mensagens.vue?vue&type=style&index=0&id=75174be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75174be2",
  null
  
)

export default component.exports